import '@/styles/globals.css'

import type { FC, ReactNode } from 'react'
import type { AppProps } from 'next/app'

import Head from 'next/head'
import { Cormorant_Garamond, Geist_Mono, Plus_Jakarta_Sans } from 'next/font/google'

const sans = Plus_Jakarta_Sans({
    subsets: ['latin']
})

const heading = Cormorant_Garamond({
    subsets: ['latin'],
    style: ['normal', 'italic']
})

const mono = Geist_Mono({
    subsets: ['latin'],
    preload: false
})

const fontVariables = `:root{--font-app-sans:${sans.style.fontFamily};--font-app-mono:${mono.style.fontFamily};--font-app-heading:${heading.style.fontFamily}}`

const App: FC<AppProps> = ({ Component, pageProps }): ReactNode => {
    return (
        <div className='h-full font-sans'>
            <Head>
                <style dangerouslySetInnerHTML={{ __html: fontVariables }} />
            </Head>

            <Component {...pageProps} />
        </div>
    )
}

export default App
